import React from "react";

export const ErrorPage: React.FC = () => {
  return <div>Something Went Wrong! Please Contact IT Team!</div>;
};
